import React, { Component } from "react";

import "./css/home.css";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="home-page">
        <div className="intro section-wrapper">
          <div className="section">
            <div className="flex-grid">
              <div className="seventy-column">
                <h1>
                  <mark>Mihai Cernusca</mark>
                </h1>
                <p>
                  Working at the intersection of product design and engineering, consistently bringing new ideas to life
                  from concept through to execution.
                  <br />
                  <a className="more" href="/about">
                    Learn more
                  </a>
                </p>
              </div>
            </div>

            <h3>Selected work</h3>
            <div className="projects">
              <a href="/flexhouse">
                <div className="box flexhouse">
                  <div className="label">
                    <div className="title">
                      <div className="name">Flexhouse</div>
                      <div className="tagline">Standardizing systems of building</div>
                    </div>
                    <div className="timeline">2024</div>
                  </div>
                  <div className="overlay" />
                </div>
              </a>
              <a href="/re-collect">
                <div className="box recollect">
                  <div className="label">
                    <div className="title">
                      <div className="name">re:collect</div>
                      <div className="tagline">Tools for the second pass</div>
                    </div>
                    <div className="timeline">2021—24</div>
                  </div>
                  <div className="overlay" />
                </div>
              </a>
              <a href="/whereby">
                <div className="box whereby">
                  <div className="label">
                    <div className="title">
                      <div className="name">Whereby</div>
                      <div className="tagline">Where better meetings happen</div>
                    </div>
                    <div className="timeline">2019—21</div>
                  </div>
                  <div className="overlay" />
                </div>
              </a>
              <a href="/america-off-balance">
                <div className="box americaoffbalance">
                  <div className="label">
                    <div className="title">
                      <div className="name">America Off Balance</div>
                      <div className="tagline">
                        Interactive storytelling experience — Let's talk about the national debt
                      </div>
                    </div>
                    <div className="timeline">2018</div>
                  </div>
                  <div className="overlay" />
                </div>
              </a>
              <a href="/swipe">
                <div className="box swipe">
                  <div className="label">
                    <div className="title">
                      <div className="name">Swipe</div>
                      <div className="tagline">Taking presentations beyond the&nbsp;projector</div>
                    </div>
                    <div className="timeline">2014—16</div>
                  </div>
                  <div className="overlay" />
                </div>
              </a>
              <a href="/gifshop">
                <div className="box gifshop">
                  <div className="label">
                    <div className="title">
                      <div className="name">GIF SHOP</div>
                      <div className="tagline">The animated .gif maker</div>
                    </div>
                    <div className="timeline">2010—14</div>
                  </div>
                  <div className="overlay" />
                </div>
              </a>
              {/* <a href="/brite">
                <div className="box brite">
                  <div className="label">
                    <div className="title">
                      <div className="name">BriteIM</div>
                      <div className="tagline">Tackling team communication</div>
                    </div>
                    <div className="timeline">2014</div>
                  </div>
                  <div className="overlay" />
                </div>
              </a> */}
              {/* <a href="/setlist">
                  <div className="box setlist">
                    <div className="label">
                      <div className="title">
                        <div className="name">Setlist</div>
                        <div className="tagline">Discover local shows using artists in your Rdio collection</div>
                      </div>
                      <div className="timeline">2012</div>
                    </div>
                    <div className="overlay" />
                  </div>
                </a> */}
            </div>

            <h3>Talks</h3>

            <div className="projects">
              <a href="/off-balance">
                <div className="box offbalance">
                  <div className="label">
                    <div className="title">
                      <div className="name">Off Balance</div>
                      <div className="tagline">Interactive Storytelling with React</div>
                    </div>
                    <div className="timeline">React Rally 2019</div>
                  </div>
                  <div className="overlay" />
                </div>
              </a>
              <a href="/preventdefault">
                <div className="box preventdefault">
                  <div className="label">
                    <div className="title">
                      <div className="name">Prevent Default</div>
                      <div className="tagline">The future of authoring tools</div>
                    </div>
                    <div className="timeline">Front Trends 2017</div>
                  </div>
                  <div className="overlay" />
                </div>
              </a>
            </div>
            <div className="flex-grid">
              <div className="seventy-column">
                <div className="elsewhere">
                  <ul>
                    <li>
                      <a href="mailto:mcernusca@gmail.com" target="_blank" rel="noopener noreferrer">
                        Email
                      </a>
                    </li>
                    <li>
                      <a href="https://bsky.app/profile/mihai.bsky.social" target="_blank" rel="noopener noreferrer">
                        Bluesky
                      </a>
                    </li>
                    <li>
                      <a href="https://github.com/mcernusca" target="_blank" rel="noopener noreferrer">
                        GitHub
                      </a>
                    </li>
                    <li>
                      <a href="https://are.na/mihai-cernusca" target="_blank" rel="noopener noreferrer">
                        Are.na
                      </a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/in/mihai-cernusca/" target="_blank" rel="noopener noreferrer">
                        LinkedIn
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/home.js